import React, { useEffect, useRef, useState } from "react";
import Header from "../../../../Components/Header/Header";
import Colors from "../../../../Constants/Colors";
import Icons from "../../../../Constants/Icons";
import EmptyData from "../../../../Components/EmptyData/EmptyData";
import {  ApiLiveSessionGetAllLiveCalls } from "../../../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import { useDispatch } from "react-redux";
import LiveSessionList from "../../../../Components/SessionList/LiveSessionList";
import UseDebounce from "../../../../Components/UseDebounce";

function LiveSession() {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [sessionListData, setSessionListData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sessionPageCount, setTotalSessionPageCount] = useState(0);
  const [pageComments, setPageComments] = useState(0);
  const commentsContainerRef = useRef(null);

  const debouncedInput = UseDebounce(searchValue, 500);


  useEffect(() => {
    setPageComments(0);
    setSessionListData([]);
    const searchQuery = debouncedInput || searchValue;
    onApiCallGetSessionList(searchQuery, 0);
  }, [debouncedInput]);

  const onApiCallGetSessionList = (search, pageComments) => {
    const searchStatus = search || "";
    let param = {
      offset: 30 * pageComments,
      limit: 30,
      search: searchStatus,
    };

  
    dispatch(setLoadingTrue());
    ApiLiveSessionGetAllLiveCalls(param)
      .then((response) => {
        setSessionListData((prevData) => [
          ...prevData,
          ...response.sessionHistoryDetails,
        ]);
        setTotalSessionPageCount(Math.ceil(response.totalSessionsCount / 30));
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  const parseAvgTime = (value) => {
    const numericValue = parseFloat(
      value.replace(/₹/g, "").replace(/\/min/g, "")
    );
    return numericValue;
  };
  const onCLickSortingArray = (property) => {
    const sortedData = [...sessionListData];
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    sortedData.sort((a, b) => {
      if (sortOrder === "asc") {
        return parseAvgTime(a[property]) - parseAvgTime(b[property]);
      } else {
        return parseAvgTime(b[property]) - parseAvgTime(a[property]);
      }
    });
    setSessionListData(sortedData);
  };
 

  const handleInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      commentsContainerRef?.current;

      
        setTimeout(() => {
      if (scrollTop <= 100) {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 100);
    
    if (scrollTop + clientHeight + 1 > scrollHeight) {
      if (sessionPageCount > pageComments + 1) {
        setPageComments((prevPage) => {
          const nextPage = prevPage + 1;
          onApiCallGetSessionList(searchValue, nextPage);
          return nextPage;
        });
      }
    }
  };

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: Colors.darkBlack,
      }}
    >
      <Header name={"Sessions / Live"} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          gap: "1rem",
        }}
      >
        <div className="astrologers-list-parent">
          <div className="fontSize24">Session list</div>
          <div className="frame-parent2">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
                fontSize: "1rem",
                color: "rgba(255, 255, 255, 0.5)",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  boxSizing: "border-box",
                  width: "15.75rem",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  padding: "0.5rem 0.5rem",
                  gap: "0.5rem",
                }}
              >
                <img
                  style={{
                    position: "relative",
                    width: "1.5rem",
                    height: "1.5rem",
                    objectFit: "contain",
                  }}
                  alt=""
                  src={Icons.ic_search}
                />
                <input
                  type="text"
                  className="searchTextInput"
                  placeholder="Search"
                  value={searchValue}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
        <LiveSessionList
          handleScroll={handleScroll}
          commentsContainerRef={commentsContainerRef}
          onSortingList={() => onCLickSortingArray("totalFees")}
          data={sessionListData}
          sessionId={"Session ID"}
          user={"User"}
          astrologer={"Astrologer"}
          dateTime={"Date & Time"}
          sessionType={"Session type"}
          duration={"Duration"}
          fees={"Fees"}
          totalfees={"Total fees"}
          status={"Status"}
        />
      </div>
      {sessionListData.length <= 0 && <EmptyData />}
    </div>
  );
}

export default LiveSession;
